var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content tdi-page" },
    [
      _c(
        "div",
        { staticClass: "tdi-toolbar-card row-data" },
        [
          _vm._m(0),
          _c(
            "el-form",
            {
              ref: "configForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "tdi-form-grid" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Phạm vi", prop: "targetType" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.handleTargetTypeChange },
                          model: {
                            value: _vm.form.targetType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "targetType", $$v)
                            },
                            expression: "form.targetType",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "CLASS" } }, [
                            _vm._v("Theo lớp"),
                          ]),
                          _c("el-radio-button", { attrs: { label: "GROUP" } }, [
                            _vm._v("Theo nhóm"),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "PACKAGE" } },
                            [_vm._v("Theo gói")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Tháng", prop: "monthAndYear" },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "135px" },
                        attrs: {
                          type: "month",
                          placeholder: "Chọn tháng",
                          "value-format": "M-yyyy",
                          format: "MM-yyyy",
                          clearable: false,
                        },
                        on: { change: _vm.handleMonthChange },
                        model: {
                          value: _vm.form.monthAndYear,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "monthAndYear", $$v)
                          },
                          expression: "form.monthAndYear",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Đợt thu", prop: "collectionTurn" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "110px" },
                          attrs: { placeholder: "Chọn đợt" },
                          on: { change: _vm.handleTurnChange },
                          model: {
                            value: _vm.form.collectionTurn,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "collectionTurn", $$v)
                            },
                            expression: "form.collectionTurn",
                          },
                        },
                        _vm._l(_vm.COLLECTION_TURNS, function (t) {
                          return _c("el-option", {
                            key: t,
                            attrs: { value: t, label: `Đợt ${t}` },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item",
                      attrs: { label: "Trạng thái học sinh" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "Chọn trạng thái" },
                          on: { change: _vm.handleKidStatusChange },
                          model: {
                            value: _vm.form.kidStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "kidStatus", $$v)
                            },
                            expression: "form.kidStatus",
                          },
                        },
                        _vm._l(_vm.kidStatusList, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: {
                              value: item.key,
                              label: item.label || item.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isClassMode
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "tdi-form-item",
                          attrs: { label: "Khối" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "140px" },
                              attrs: { placeholder: "Chọn khối" },
                              on: { change: _vm.handleGradeChange },
                              model: {
                                value: _vm.form.idGrade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "idGrade", $$v)
                                },
                                expression: "form.idGrade",
                              },
                            },
                            _vm._l(_vm.gradeOfSchoolList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.gradeName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isClassMode
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "tdi-form-item",
                          attrs: { label: "Lớp", prop: "idClass" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "175px" },
                              attrs: { placeholder: "Chọn lớp" },
                              on: { change: _vm.handleClassChange },
                              model: {
                                value: _vm.form.idClass,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "idClass", $$v)
                                },
                                expression: "form.idClass",
                              },
                            },
                            _vm._l(_vm.classList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.className,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isGroupMode
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "tdi-form-item",
                          attrs: { label: "Nhóm", prop: "idGroup" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "220px" },
                              attrs: { placeholder: "Chọn nhóm" },
                              on: { change: _vm.handleGroupChange },
                              model: {
                                value: _vm.form.idGroup,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "idGroup", $$v)
                                },
                                expression: "form.idGroup",
                              },
                            },
                            _vm._l(_vm.kidGroupList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: item.nameGroup,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isPackageMode
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "tdi-form-item",
                          attrs: { label: "Gói dịch vụ", prop: "idPackage" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "220px" },
                              attrs: { placeholder: "Chọn gói" },
                              on: { change: _vm.handlePackageChange },
                              model: {
                                value: _vm.form.idPackage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "idPackage", $$v)
                                },
                                expression: "form.idPackage",
                              },
                            },
                            _vm._l(_vm.packageList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { value: item.id, label: item.name },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "tdi-form-grid",
                  staticStyle: { "margin-top": "12px" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item tdi-form-item--wide",
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n               Khoảng thời gian\n               "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "Thời gian phiếu thu có hiệu lực",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question tdi-help-icon ml-1",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          type: "daterange",
                          format: "dd-MM-yyyy",
                          "range-separator": "–",
                          "start-placeholder": "Từ ngày",
                          "end-placeholder": "Đến ngày",
                          "picker-options": _vm.pickerOptions,
                        },
                        model: {
                          value: _vm.form.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "dateRange", $$v)
                          },
                          expression: "form.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item tdi-form-item--wide",
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                Thời gian tính trước\n                "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "Thời gian tính trước dùng để tính theo lịch học",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question tdi-help-icon ml-1",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          type: "daterange",
                          format: "dd-MM-yyyy",
                          "range-separator": "–",
                          "start-placeholder": "Từ ngày",
                          "end-placeholder": "Đến ngày",
                          "picker-options": _vm.pickerOptions,
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.preCalcDateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "preCalcDateRange", $$v)
                          },
                          expression: "form.preCalcDateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item tdi-form-item--wide",
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n                Thời gian tính sau\n                "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "Thời gian tính sau dùng để tính dựa trên dữ liệu điểm danh thực tế",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question tdi-help-icon ml-1",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          type: "daterange",
                          format: "dd-MM-yyyy",
                          "range-separator": "–",
                          "start-placeholder": "Từ ngày",
                          "end-placeholder": "Đến ngày",
                          "picker-options": _vm.pickerOptions,
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.postCalcDateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "postCalcDateRange", $$v)
                          },
                          expression: "form.postCalcDateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "tdi-form-item tdi-form-item--wide",
                      attrs: { label: "Mô tả đợt thu" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "290px" },
                        attrs: {
                          placeholder: "Nhập mô tả đợt thu",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "tdi-option-row" }, [
                _c("div", { staticClass: "tdi-option-block" }, [
                  _c("span", { staticClass: "tdi-option-label" }, [
                    _vm._v("Khoản thu"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "tdi-option-content" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { indeterminate: _vm.isFeesIndeterminate },
                          on: { change: _vm.handleCheckAllFees },
                          model: {
                            value: _vm.checkAllFees,
                            callback: function ($$v) {
                              _vm.checkAllFees = $$v
                            },
                            expression: "checkAllFees",
                          },
                        },
                        [
                          _vm._v(
                            "\n                Chọn tất cả\n              "
                          ),
                        ]
                      ),
                      _c("span", { staticClass: "tdi-fee-count" }, [
                        _vm._v(
                          "Đã chọn: " + _vm._s(_vm.form.selectedFees.length)
                        ),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "tdi-detail-link",
                          on: {
                            click: function ($event) {
                              _vm.feeDialogVisible = true
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-view" }),
                          _vm._v(" Chi tiết\n              "),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm.isClassMode
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "tdi-option-block tdi-option-block--attendance",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "tdi-option-label" },
                          [
                            _vm._v(
                              "\n              Thông tin điểm danh bổ sung, dữ liệu điểm danh\n              "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.attendanceTooltipContent,
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question tdi-help-icon",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#909399",
                                    "margin-left": "4px",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "tdi-option-content" },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: false },
                                model: {
                                  value: _vm.form.monthBeforeOrAfter,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "monthBeforeOrAfter",
                                      $$v
                                    )
                                  },
                                  expression: "form.monthBeforeOrAfter",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Tháng hiện tại (" +
                                    _vm._s(_vm.currentAttendanceMonthText) +
                                    ")\n              "
                                ),
                              ]
                            ),
                            _c(
                              "el-radio",
                              {
                                attrs: { label: true },
                                model: {
                                  value: _vm.form.monthBeforeOrAfter,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "monthBeforeOrAfter",
                                      $$v
                                    )
                                  },
                                  expression: "form.monthBeforeOrAfter",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Tháng trước (" +
                                    _vm._s(_vm.previousAttendanceMonthText) +
                                    ")\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "tdi-attendance-hint" }, [
                          _c("i", { staticClass: "el-icon-info" }),
                          _vm.form.monthBeforeOrAfter
                            ? _c("span", [
                                _vm._v(
                                  "\n                Đang chọn: Lấy dữ liệu điểm danh của "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    "Tháng " +
                                      _vm._s(_vm.previousAttendanceMonthText)
                                  ),
                                ]),
                                _vm._v(" (tháng trước)\n              "),
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n                Đang chọn: Lấy dữ liệu điểm danh của "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    "Tháng " +
                                      _vm._s(_vm.currentAttendanceMonthText)
                                  ),
                                ]),
                                _vm._v(" (tháng hiện tại)\n              "),
                              ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "tdi-option-block" }, [
                  _c("span", { staticClass: "tdi-option-label" }, [
                    _vm._v("Thiếu / Thừa"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "tdi-option-content" },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: true },
                          on: {
                            change: function ($event) {
                              return _vm.handleBalanceRadio("allTransaction")
                            },
                          },
                          model: {
                            value: _vm.form.allTransaction,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "allTransaction", $$v)
                            },
                            expression: "form.allTransaction",
                          },
                        },
                        [_vm._v("Tất cả")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: true },
                          on: {
                            change: function ($event) {
                              return _vm.handleBalanceRadio(
                                "forwardTransaction"
                              )
                            },
                          },
                          model: {
                            value: _vm.form.forwardTransaction,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "forwardTransaction", $$v)
                            },
                            expression: "form.forwardTransaction",
                          },
                        },
                        [_vm._v("Kết chuyển")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: true },
                          on: {
                            change: function ($event) {
                              return _vm.handleBalanceRadio(
                                "noForwardTransaction"
                              )
                            },
                          },
                          model: {
                            value: _vm.form.noForwardTransaction,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "noForwardTransaction", $$v)
                            },
                            expression: "form.noForwardTransaction",
                          },
                        },
                        [_vm._v("Không chuyển")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "tdi-kid-list-block" },
                [
                  _c("div", { staticClass: "tdi-kid-list-head" }, [
                    _c("div", [
                      _c("p", { staticClass: "tdi-kid-list-title" }, [
                        _c("i", { staticClass: "el-icon-user-solid" }),
                        _vm._v(" Danh sách học sinh nháp\n              "),
                      ]),
                      _c("p", { staticClass: "tdi-kid-list-subtitle" }, [
                        _vm._v(
                          "\n                Chọn học sinh để tạo phiếu thu nháp.\n              "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "tdi-kid-list-meta" },
                      [
                        _c("span", [
                          _vm._v("Đã chọn: "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.form.listIdKids.length)),
                          ]),
                          _vm._v(" / " + _vm._s(_vm.kidDraftList.length)),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", icon: "el-icon-refresh" },
                            on: { click: _vm.fetchKidsInDraft },
                          },
                          [_vm._v("Tải lại")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "tdi-kid-toolbar" },
                    [
                      _c("el-input", {
                        staticStyle: { "max-width": "320px" },
                        attrs: {
                          placeholder: "Tìm theo mã hoặc tên học sinh...",
                          "prefix-icon": "el-icon-search",
                          clearable: "",
                        },
                        model: {
                          value: _vm.kidKeyword,
                          callback: function ($$v) {
                            _vm.kidKeyword = $$v
                          },
                          expression: "kidKeyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.kidDraftLoading,
                          expression: "kidDraftLoading",
                        },
                      ],
                      ref: "kidDraftTable",
                      staticClass: "sk-table tdi-kid-table",
                      attrs: {
                        data: _vm.filteredKidDraftList,
                        "empty-text": _vm.kidDraftLoading
                          ? "Đang tải danh sách học sinh..."
                          : "Chưa có học sinh phù hợp",
                        "max-height": _vm.$tableMaxHeight,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(255,255,255,0)",
                        border: "",
                        "row-key": "id",
                      },
                      on: { "selection-change": _vm.handleKidSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "52",
                          align: "center",
                          "reserve-selection": true,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "kidCode",
                          label: "Mã HS",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "Họ và tên",
                          "min-width": "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Trạng thái",
                          width: "120",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.kidStatusTagType(row.status),
                                      size: "mini",
                                      effect: "light",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.kidStatusLabel(row.status)) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tdi-action-row" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-document-checked",
                        loading: _vm.isLoading,
                      },
                      on: { click: _vm.handleGenerate },
                    },
                    [
                      _vm._v(
                        "\n            Xem trước phiếu thu nháp\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.hasResult
        ? _c("div", { staticClass: "tdi-table-card row-data" }, [
            _c(
              "div",
              { staticClass: "tdi-card-head" },
              [
                _c("div", [
                  _vm._m(1),
                  _c("div", { staticClass: "tdi-card-subtitle" }, [
                    _c("p", [
                      _vm._v("Tổng "),
                      _c("strong", [_vm._v(_vm._s(_vm.invoiceList.length))]),
                      _vm._v(" phiếu."),
                    ]),
                    _vm._m(2),
                  ]),
                ]),
                _c(
                  "el-tag",
                  {
                    attrs: { type: "warning", effect: "dark", size: "medium" },
                  },
                  [
                    _c("i", { staticClass: "el-icon-warning-outline" }),
                    _vm._v(" Dữ liệu xem trước – chưa lưu\n        "),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "tdi-table-wrapper" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    ref: "invoiceDraftTable",
                    staticClass: "sk-table tdi-main-table",
                    attrs: {
                      data: _vm.invoiceList,
                      "empty-text": _vm.emptyText,
                      "element-loading-text": _vm.$tableLoading,
                      "element-loading-spinner": "el-icon-loading",
                      "element-loading-background": "rgba(255,255,255,0)",
                      "max-height": _vm.$tableMaxHeight,
                      "summary-method": _vm.getSummaries,
                      "show-summary": "",
                      border: "",
                      "row-key": "idx",
                    },
                    on: {
                      "selection-change":
                        _vm.handleOfficialInvoiceSelectionChange,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "52",
                        align: "center",
                        "reserve-selection": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "STT",
                        width: "50",
                        align: "center",
                        fixed: "left",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Họ tên",
                        prop: "fullName",
                        width: "250",
                        fixed: "left",
                        align: "left",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: `Mã HS: ${row.studentCode}`,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "tdi-student-name-cell" },
                                      [_vm._v(_vm._s(row.fullName))]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2341709360
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Biệt danh",
                        prop: "nickName",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(row.nickName || "—")),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2352929144
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Thông tin bổ sung",
                        width: "130",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Xem thông tin bổ sung",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "tdi-additional-info-btn",
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-info",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleOpenAdditionalInfo(
                                            row
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3881685442
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Trạng thái",
                        align: "center",
                        width: "140",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.statusTagType(row.status),
                                      size: "mini",
                                      effect: "light",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.statusLabel(row.status)) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1905918093
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Đợt",
                        prop: "turn",
                        width: "60",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Tháng-Năm",
                        width: "100",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.month) +
                                    "/" +
                                    _vm._s(row.year) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4283044710
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Thiếu/Thừa trước",
                        prop: "beforeMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.beforeMoney < 0
                                        ? "tdi-money--negative"
                                        : "tdi-money--positive",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            row.beforeMoney
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1269688450
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Phải thu tháng này",
                        prop: "sumMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "tdi-money tdi-money--bold" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatCurrency")(row.sumMoney)
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2885206753
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Đã thu",
                        prop: "collectedMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "tdi-fee-amount",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEditCollectedMoney(row)
                                      },
                                    },
                                  },
                                  [
                                    row.collectedMoney
                                      ? _c(
                                          "span",
                                          { staticClass: "tdi-money" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  row.collectedMoney
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tdi-money tdi-text-muted",
                                          },
                                          [_vm._v("-")]
                                        ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1259342145
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Tiền mặt",
                        prop: "cashMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "tdi-money" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(row.cashMoney)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        945868466
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Chuyển khoản",
                        prop: "transferMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("span", { staticClass: "tdi-money" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatCurrency")(
                                        row.transferMoney
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        893443520
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Thiếu/Thừa còn lại",
                        prop: "afterMoney",
                        align: "right",
                        "min-width": "130",
                        "class-name": "tdi-finance-column",
                        "label-class-name": "tdi-finance-header",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class:
                                      row.afterMoney < 0
                                        ? "tdi-money--negative"
                                        : "tdi-money--positive",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            row.afterMoney
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2673081762
                      ),
                    }),
                    _vm._l(_vm.feeColumns, function (item, index) {
                      return _c("el-table-column", {
                        key: `${item.prop}-${index}`,
                        attrs: {
                          align: "right",
                          width: "140",
                          label: item.label,
                          prop: item.prop,
                          "class-name": "tdi-fee-column",
                          "label-class-name": "tdi-fee-header",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: scope.column.label,
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.column.label)),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "tdi-fee-amount",
                                      attrs: {
                                        type: "text",
                                        disabled: !_vm.isFeeEditable(
                                          row,
                                          item.key
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEditRevenueDetail(
                                            row,
                                            item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.hasFeeAmount(row[item.prop])
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tdi-money tdi-money--fee",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm._f("formatCurrency")(
                                                      row[item.prop]
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tdi-money tdi-money--fee",
                                            },
                                            [_vm._v("-")]
                                          ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "tdi-table-action-row" },
              [
                _c("div", { staticClass: "tdi-table-action-summary" }, [
                  _c("span", [
                    _vm._v(
                      "\n            Đã chọn phát hành chính thức:\n            "
                    ),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.selectedDraftInvoiceRows.length)),
                    ]),
                    _vm._v(
                      "\n            / " +
                        _vm._s(_vm.invoiceList.length) +
                        " phiếu\n          "
                    ),
                  ]),
                  _vm.selectedDraftInvoiceRows.length === 0
                    ? _c("span", { staticClass: "tdi-table-action-hint" }, [
                        _vm._v(
                          "\n            Chọn ít nhất một phiếu nháp để khởi tạo phiếu thu chính thức.\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      icon: "el-icon-collection",
                      loading: _vm.officialInvoiceLoading,
                      disabled:
                        _vm.officialInvoiceLoading ||
                        _vm.selectedDraftInvoiceRows.length === 0,
                    },
                    on: { click: _vm.handleCreateOfficialInvoices },
                  },
                  [
                    _vm._v(
                      "\n          Khởi tạo phiếu thu chính thức\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("edit-revenue-detail-dialog", {
        ref: "editDetailDialog",
        on: { saved: _vm.handleRevenueDetailSaved },
      }),
      _c("edit-collected-money-draft-dialog", {
        ref: "editCollectedMoneyDialog",
        on: { saved: _vm.handleCollectedMoneySaved },
      }),
      _c("additional-info-draft-dialog", {
        attrs: {
          visible: _vm.additionalInfoDialogVisible,
          loading: _vm.additionalInfoLoading,
          info: _vm.additionalInfoData || {},
          month: _vm.additionalInfoContext.month,
          year: _vm.additionalInfoContext.year,
          turn: _vm.additionalInfoContext.turn,
          "student-name": _vm.additionalInfoContext.studentName,
        },
        on: {
          "update:visible": function ($event) {
            _vm.additionalInfoDialogVisible = $event
          },
          saved: _vm.handleAdditionalInfoSaved,
          close: function ($event) {
            _vm.additionalInfoData = null
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Danh sách khoản thu",
            visible: _vm.feeDialogVisible,
            width: "580px",
            top: "6vh",
            "before-close": () => {
              _vm.feeDialogVisible = false
            },
          },
          on: {
            "update:visible": function ($event) {
              _vm.feeDialogVisible = $event
            },
            open: _vm.handleFeeDialogOpen,
          },
        },
        [
          _c(
            "div",
            { staticClass: "tdi-fd-toolbar" },
            [
              _c("el-input", {
                staticStyle: { "max-width": "320px" },
                attrs: {
                  placeholder: "Tìm theo mã hoặc tên khoản...",
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                },
                model: {
                  value: _vm.feeKeyword,
                  callback: function ($$v) {
                    _vm.feeKeyword = $$v
                  },
                  expression: "feeKeyword",
                },
              }),
              _c("span", { staticClass: "tdi-fd-count" }, [
                _vm._v("\n          Đã chọn:\n          "),
                _c("strong", { staticClass: "tdi-fd-count-val" }, [
                  _vm._v(_vm._s(_vm.form.selectedFees.length)),
                ]),
                _vm._v(
                  "\n          / " +
                    _vm._s(_vm.feeOptions.length) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tdi-fd-list" },
            [
              _vm.feeOptions.length === 0
                ? _c("div", { staticClass: "tdi-fd-empty" }, [
                    _c("i", {
                      staticClass: "el-icon-document-remove tdi-fd-empty-icon",
                    }),
                    _c("p", [
                      _vm._v(
                        "Chưa có khoản thu nào. Vui lòng chọn lớp / nhóm và tháng trước."
                      ),
                    ]),
                  ])
                : [
                    _vm.filteredFeeOptions.length === 0
                      ? _c("div", { staticClass: "tdi-fd-empty" }, [
                          _c("i", {
                            staticClass: "el-icon-search tdi-fd-empty-icon",
                          }),
                          _c("p", [
                            _vm._v("Không tìm thấy khoản thu phù hợp."),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.filteredFeeOptions, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "tdi-fd-item",
                          class: {
                            "tdi-fd-item--checked":
                              _vm.form.selectedFees.indexOf(item.id) !== -1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleFeeItem(item.id)
                            },
                          },
                        },
                        [
                          _c("el-checkbox", {
                            staticClass: "tdi-fd-checkbox",
                            attrs: {
                              value:
                                _vm.form.selectedFees.indexOf(item.id) !== -1,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggleFeeItem(item.id)
                              },
                            },
                            nativeOn: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          }),
                          item.code
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: `Mã khoản: ${item.code}`,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "tdi-fd-label" }, [
                                    _vm._v(_vm._s(item.name)),
                                  ]),
                                ]
                              )
                            : _c("span", { staticClass: "tdi-fd-label" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                        ],
                        1
                      )
                    }),
                  ],
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.feeDialogVisible = false
                    },
                  },
                },
                [_vm._v("Xác nhận")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.feeDialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tdi-card-head" }, [
      _c("div", [
        _c("p", { staticClass: "tdi-card-title" }, [
          _c("i", { staticClass: "el-icon-document" }),
          _vm._v(" Sinh Phiếu Thu Nháp\n          "),
        ]),
        _c("p", { staticClass: "tdi-card-subtitle" }, [
          _vm._v(
            "\n            Cấu hình bộ lọc để tạo dữ liệu xem trước. Bao gồm thông tin bổ sung chi tiết cho phiếu thu nháp (điểm danh, ghi chú, đợt thu).\n          "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "tdi-card-title" }, [
      _c("i", { staticClass: "el-icon-tickets" }),
      _vm._v(" Danh Sách Phiếu Thu Nháp\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "tdi-info-list" }, [
      _c("li", [
        _vm._v("Mã phiếu thu sẽ được sinh khi khởi tạo phiếu chính thức."),
      ]),
      _c("li", [
        _vm._v(
          "Mỗi 1 đợt thu của 1 học sinh trong 1 tháng thì chỉ có 1 phiếu thu duy nhất."
        ),
      ]),
      _c("li", [
        _vm._v(
          "Phiếu thu cũ (nếu có) sẽ bị ghi đè lên bởi phiếu thu mới, nếu phiếu thu cũ đã được thanh toán trực tuyến thì không thể khởi tạo phiếu thu mới cùng đợt trong tháng cho học sinh đó."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }